import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { PageBreakNodeView } from "@/components/editor/nodeviews/PageBreakNodeView";

export const PageBreakBlock = Node.create({
  name: "pageBreakBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="page-break-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "page-break-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(PageBreakNodeView);
  },
});
